import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ProductCard from "../components/ProductCard";
import { DroppingSoonGrid } from "../components/DroppingSoonGrid";
import { api } from "../lib/api";

const SPANS = [
  "md:col-span-6 lg:col-span-7",
  "md:col-span-6 lg:col-span-5",
  "md:col-span-6 lg:col-span-5",
  "md:col-span-6 lg:col-span-7",
];

export default function SportsPage() {
  const [products, setProducts] = useState([]);
  const [comingSoon, setComingSoon] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get("/products"), api.get("/coming-soon")])
      .then(([p, c]) => {
        setProducts(p.data.filter((x) => x.category === "sports"));
        setComingSoon(c.data.filter((x) => x.category === "Sports"));
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <Header />
      <section className="border-b border-[#C6FF00]/20 bg-gradient-to-b from-[#0B0E02] to-transparent">
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-12 md:pt-28">
          <p className="af-mono text-[10px] uppercase tracking-[0.3em] text-[#C6FF00] mb-4">
            // Game on
          </p>
          <h1
            className="af-display text-5xl md:text-7xl font-black uppercase tracking-tighter leading-[0.92]"
            data-testid="sports-title"
          >
            Sports
          </h1>
          <p className="text-zinc-400 mt-6 max-w-2xl">
            Airless, 3D printed sports gear — honeycomb-lattice balls that play
            like the real thing and never go flat.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        {loading && (
          <p className="af-mono text-zinc-500 text-sm" data-testid="sports-loading">
            Loading gear…
          </p>
        )}

        {products.length > 0 && (
          <div
            className="grid grid-cols-1 md:grid-cols-12 gap-6"
            data-testid="sports-available-grid"
          >
            {products.map((p, i) => (
              <ProductCard key={p.slug} product={p} span={SPANS[i % SPANS.length]} showColors />
            ))}
          </div>
        )}

        <DroppingSoonGrid items={comingSoon} accent="#C6FF00" showColors />
      </section>
      <Footer />
    </div>
  );
}
